import { Action } from '@ngrx/store';
import { MfaInterface } from '../../models/mfa.interface';

export enum EMfaActions {
  UpdateMfaVisibility = '[MFA] MFA pop-up'
}

export class UpdateMfaVisibility implements Action {
  public readonly type = EMfaActions.UpdateMfaVisibility;
  constructor(public payload: MfaInterface) {}
}

export type MfaActions = UpdateMfaVisibility;
